import styled from 'styled-components'
import {device, size} from '@/styles/template';



export const AdWrapper = styled.div`
    max-width: ${size.laptop};
    margin-top: 2rem;
  
    @media ${device.mobileL} {
      margin: 6rem auto 0;
    }
`

export const AdProcessTestMobile = styled.div`
	min-height: 200px;
	max-height: 300px;

	@media (min-width: 481px) {
	  display: none;
	}
`;

export const AdProcessPC = styled.div`
  	overflow: hidden;
  	min-height: 320px;

  @media (max-width: 480px) {
      display: none;
  }
`;